import { Component } from '@angular/core';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-about-header',
  imports: [TranslatePipe],
  templateUrl: './about-header.html',
  styleUrl: './about-header.scss',
})
export class AboutHeader {}
